import { useMutation, UseMutationResult, useQuery, UseQueryResult } from '@tanstack/react-query';

import PlaidService from 'src/services/plaid.service';

const queryKey = 'plaid';

export function usePlaidToken(): UseQueryResult<string> {
    return useQuery<string>({
        queryKey: [queryKey],
        queryFn: async () => await PlaidService.createLinkToken()
    });
}

export const usePlaidReconnectInstitution = (): UseMutationResult<string, unknown, number> => {
    return useMutation({
        mutationFn: async (id: number) => await PlaidService.reconnectInstitution(id)
    });
};

export const usePlaidResetInstitutionLogin = (): UseMutationResult<void, unknown, number> => {
    return useMutation({
        mutationFn: async (id: number) => await PlaidService.resetInstitutionLogin(id)
    });
};
